const hash = window.location.hash;
// Remueve el símbolo '#' del inicio
const id = hash.startsWith('#') ? hash.substring(1) : hash;
if(id === 'formulario'){
  window.scrollTo({
    top: document.getElementById('formulario').offsetTop - 300,
    behavior: 'smooth'
  });  
}else{
  console.log("no es formulario");
}